class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector("dialog");
    this.onBodyClickHandler = this.onBodyClick.bind(this);
    this.bindEvents();
  }

  bindEvents() {
    Array.from(this.querySelectorAll(".dialog-close")).forEach((element) => {
      element.addEventListener("click", (event) => {
        event.preventDefault();
        this.close();
      });
    });
    this.querySelectorAll("summary").forEach((summary) => {
      summary.addEventListener("click", this.onSummaryClick.bind(this));
    });
    this.dialog
      .querySelectorAll("button.menu-drawer__close-button")
      .forEach((button) => {
        button.addEventListener("click", this.onCloseButtonClick.bind(this));
      });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    detailsElement.toggleAttribute("open");
  }

  onSummaryClick(event) {}

  open() {
    document.documentElement.classList.add("overflow-hidden");
    this.dialog.showModal();
    document.addEventListener("click", this.onBodyClickHandler);
  }

  close() {
    this.dialog.close();
    document.documentElement.classList.remove("overflow-hidden");
    document.removeEventListener("click", this.onBodyClickHandler);
  }

  onBodyClick(event) {
    if (event.target !== this.dialog) return;
    this.close();
  }
}
customElements.define("mobile-menu", MobileMenu);
